import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { clearAuthMe, fetchAuthMe } from '../../store/AuthmeSlice/authmeSlice';
import { clearUser } from '../../store/UserSlice/userSlice';

import { CiWifiOff } from "react-icons/ci";
import LottieHandler from '../LottieHandler/LottieHandler';

import './checkPrivateRouteAuth.scss'

const CheckPrivateRouteAuth = ({ children }) => {

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const location = useLocation(); // get current location
 
  const { data, status, error } = useSelector((state) => state.authme);

  const token = useSelector(state => state.user.token)

  const [loading, setLoading] = useState(false);


 
  useEffect(() => {

    if(status === 'idle' && token){
      dispatch(fetchAuthMe())
      setLoading(true)
    }
    else if (status === 'loading') {
      setLoading(true);
    } else {
      setLoading(false);
    }
  
  }, [status]);



//haneling the logout if the error for unautherized showed

  const handelLogOut = ()=>{
    // Clear local storage
    dispatch(clearAuthMe())
    dispatch(clearUser());

    const serializedState = localStorage.getItem('state');

    if (serializedState !== null) {
       localStorage.removeItem('state');

     }
    
    // Dispatch logout action to clear Redux state


    // Navigate to the login page or another page
    navigate('/login');
}




  if (loading) {

    return <div  
        style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',

         }}>
      
        <LottieHandler type="kite" message="يتم التحميل ..." />
    </div>;
  }

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />; // Save original location
  }

  if(error){
    return <div className='No_internet_access_errorPage'>
            <div className='No_wifi_part'><CiWifiOff className='No_wifi_icon'/></div>
            <span className='No_wifi_text' dir='rtl'>تحقق من اتصالك بالانترنيت و ان تكرر ظهور هذه الصفحة يرجى</span>
            <span className='No_wifi_text' dir='rtl' style={{textDecoration:"underline" , color:"blue",cursor:"pointer"}}  onClick={()=>{handelLogOut()}}>تسجيل الخروج</span>
         </div>
  } 

  if(status === "succeeded"){

  return children;
  }
};

export default CheckPrivateRouteAuth;
